import { Chip } from './Chip.page'
import { ChipVariant } from './Chip.types'

export type ChipStatusProps = {
  state?: 'custom' | string
  customOpt?: { text: string, variant: ChipVariant }
}

export const ChipStatus = ({ state, customOpt }: ChipStatusProps) => {
  if (!state) return <>-</>
  switch (state.toLowerCase()) {
    case 'active':
      return <Chip variant='success'>Active</Chip>
    case 'suspend':
      return <Chip variant='dark-gray'>Account Suspended</Chip>
    case 'unverified':
      return <Chip variant='warning'>Need Verification</Chip>
    case 'reject':
      return <Chip variant='danger'>ID Rejected</Chip>
    case 'deleted':
      return <Chip variant='gray'>Account Deleted</Chip>
    case 'inactive':
      return <Chip variant='gray'>Inactive</Chip>
    case 'pending':
      return <Chip variant='warning'>Pending</Chip>
    case 'in progress':
    case 'in_progress':
      return <Chip variant='warning'>In Progress</Chip>
    case 'completed':
      return <Chip variant='success'>Completed</Chip>
    case 'reset':
      return <Chip variant='gray'>Reset</Chip>
    case 'applied':
      return <Chip variant='success'>Applied</Chip>
    case 'approved':
      return <Chip variant='success'>Approved</Chip>
    case 'deleted_account':
      return <Chip variant='gray'>Deleted Account</Chip>
    case 'not_applied':
      return <Chip variant='danger'>Not Applied</Chip>
    case 'rejected':
      return <Chip variant='danger'>Rejected</Chip>
    case 'used':
      return <Chip variant='gray'>Used</Chip>
    case 'redeemed':
      return <Chip variant='warning'>Redeemed</Chip>
    case 'available':
      return <Chip variant='success'>Available</Chip>
    case 'scheduled':
      return <Chip variant='warning'>Scheduled</Chip>
    case 'sent':
      return <Chip variant='success'>Sent</Chip>
    case 'reguler':
    case 'regular':
      return <Chip variant='success'>Reguler</Chip>
    case 'special':
      return <Chip variant='info'>Special</Chip>
    case 'warning':
      return <Chip variant='danger'>Warning</Chip>
    case 'reseller':
      return <Chip variant='success'>Reseller</Chip>
    case 'influencer':
    case 'kol/influencer':
      return <Chip variant='success'>KOL/Influencer</Chip>
    case 'tenant_owner':
    case 'karyawan tenant/owner tenant':
      return <Chip variant='success'>Karyawan Tenant/Owner Tenant</Chip>
    case 'management':
      return <Chip variant='success'>Management</Chip>
    case 'family_owner':
    case 'family owner':
      return <Chip variant='success'>Family Owner</Chip>
    case 'claimed':
      return <Chip variant='warning'>Claimed</Chip>
    case 'expired':
      return <Chip variant='danger'>Expired</Chip>
    case 'void':
      return <Chip variant='danger'>Void</Chip>
    case 'used promo':
      return <Chip variant='gray'>Used Promo</Chip>
    case 'request':
      return <Chip variant='gray'>Requested</Chip>
    case 'success':
      return <Chip variant='success'>Success</Chip>
    case 'login':
      return <Chip variant='info'>Login</Chip>
    case 'logout':
      return <Chip variant='info'>Logout</Chip>
    case 'edited':
      return <Chip variant='warning'>Edited</Chip>
    case 'reactivate':
      return <Chip variant='success'>Reactivate</Chip>
    case 'suspended audit trail':
      return <Chip variant='danger'>Suspended</Chip>
    case 'added':
      return <Chip variant='success'>Added</Chip>
    case 'deleted audit trail':
      return <Chip variant='danger'>Deleted</Chip>
    case 'buy audit trail':
      return <Chip variant='success'>Buy Reward</Chip>
    case 'voided audit trail':
      return <Chip variant='danger'>Void</Chip>
    case 'finish':
      return <Chip variant='warning'>FINISH</Chip>
    case 'upcoming':
      return <Chip variant='gray'>UPCOMING</Chip>
    case 'ongoing':
      return <Chip variant='success'>ONGOING</Chip>
    case 'draft':
      return <Chip variant='danger'>Draft</Chip>
    case 'valid':
      return <Chip variant='success'>Valid</Chip>
    case 'invalid':
      return <Chip variant='danger'>Invalid</Chip>
    case 'custom':
      if (customOpt) return <Chip variant={customOpt?.variant}>{customOpt?.text}</Chip>;
      return <>-</>
    default:
      return <>-</>
  }
}

export default ChipStatus
